<template>
  <div ref="input" class="full input">
    <label class="optionalPosition">
      {{ input.label }}
      <p class="optional" v-if="input.optional">(optional)</p>
    </label>

    <div v-if="input.type == 'date_dd_mm_yyyy'">
      <input class="full" v-model="answer" type="date" @input="formatDate" />
    </div>
    <div v-else>
      <input class="full" v-model="answer" type="month" @input="formatDate" />
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "DateInput",
  props: ["input", "questionIndex", "answerKey"],
  data() {
    return {
      answer: null
    };
  },
  mounted() {},
  created() {
    this.answer = this.input.value;
    let day;
    let month;
    let year;
    if (this.input.type == "date_dd_mm_yyyy") {
    } else {
      month = moment().format("MM");
      year = moment().format("YYYY");
      this.answer = year + "-" + month;
      console.log(this.answer);
    }
  },
  watch: {},
  firestore() {
    return {};
  },
  methods: {
    formatDate(e) {
      let tempDate = this.answer.split("-");
      var today = new Date();
      let year = tempDate[0];
      let month = tempDate[1];
      let day;

      if (year > today.getFullYear()) {
        year = today.getFullYear();
      }
      if (year == today.getFullYear() && month > today.getMonth() + 1) {
        if (today.getMonth() + 1 < 10) month = "0" + (today.getMonth() + 1);
        else month = today.getMonth() + 1;
      }
      if (this.input.type == "date_dd_mm_yyyy") {
        day = tempDate[2];
        if (
          year == today.getFullYear() &&
          month == today.getMonth() + 1 &&
          day > today.getDate()
        ) {
          if (today.getDate() < 10) day = "0" + today.getDate();
          else day = today.getDate();
        }
        this.answer = year + "-" + month + "-" + day;
      } else {
        this.answer = year + "-" + month;
      }
      this.input.value =this.answer;
      this.$emit(
        "updateAnswer",
        this.questionIndex,
        this.answerKey,
        this.answer
      );
    }
  }
};
</script>

<style scoped lang="scss">
input {
  font-family: "Open Sans", sans-serif;
  -webkit-appearance: none;
}
</style>
